var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CardBase",
        [
          _c(
            "MacroSubHeader",
            { attrs: { title: "Prospectos", icon: "fas fa-users fa-1x" } },
            [
              _c(
                "template",
                { slot: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.filter-collapse",
                          modifiers: { "filter-collapse": true }
                        }
                      ],
                      attrs: {
                        size: "small",
                        plain: "",
                        title: "Mostrar/Ocultar Filtros"
                      }
                    },
                    [
                      _c("b-icon-filter"),
                      _vm._v(" \n          Filtros\n          "),
                      _vm.hasActiveFilters
                        ? _c(
                            "b-badge",
                            {
                              staticClass: "ml-1",
                              attrs: { variant: "primary", pill: "" }
                            },
                            [_vm._v("!")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        plain: "",
                        disabled: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          return _vm.loadProspectos(true)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "el-icon-tickets" }),
                      _vm._v("\n          Exportar prospectos\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", plain: "" },
                      on: {
                        click: function($event) {
                          return _vm.navigateToSPC()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "el-icon-search" }),
                      _vm._v("\n          Consultar SPC\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.navigateToProspectCreate()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v("\n          Novo Prospecto\n        ")
                    ]
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "CardBase",
            [
              _c(
                "b-collapse",
                {
                  staticClass: "mb-3",
                  attrs: { id: "filter-collapse" },
                  model: {
                    value: _vm.showFiltro,
                    callback: function($$v) {
                      _vm.showFiltro = $$v
                    },
                    expression: "showFiltro"
                  }
                },
                [
                  _c(
                    "b-card",
                    {
                      attrs: { "body-class": "shadow-sm" },
                      scopedSlots: _vm._u([
                        {
                          key: "footer",
                          fn: function() {
                            return [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "text-right" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            variant: "outline-secondary",
                                            disabled: _vm.loading
                                          },
                                          on: { click: _vm.clearFilters }
                                        },
                                        [
                                          _c("b-icon-x-circle"),
                                          _vm._v(
                                            " Limpar Filtros\n                "
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "primary",
                                            disabled: _vm.loading
                                          },
                                          on: { click: _vm.onSearch }
                                        },
                                        [
                                          _c("b-icon-search"),
                                          _vm._v(" Buscar\n                  "),
                                          _vm.loading
                                            ? _c("b-spinner", {
                                                attrs: { small: "" }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onSearch.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Nome Empresa" } },
                                    [
                                      _c("b-form-input", {
                                        model: {
                                          value: _vm.filters.empresa,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "empresa",
                                              $$v
                                            )
                                          },
                                          expression: "filters.empresa"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "CNPJ" } },
                                    [
                                      _c("b-form-input", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value: ["##.###.###/####-##"],
                                            expression: "['##.###.###/####-##']"
                                          }
                                        ],
                                        model: {
                                          value: _vm.filters.cnpj,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "cnpj", $$v)
                                          },
                                          expression: "filters.cnpj"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Responsável" } },
                                    [
                                      _c("b-form-input", {
                                        model: {
                                          value: _vm.filters.responsavel,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "responsavel",
                                              $$v
                                            )
                                          },
                                          expression: "filters.responsavel"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Código Distribuidor" } },
                                    [
                                      _c("b-form-input", {
                                        model: {
                                          value:
                                            _vm.filters.codigo_distribuidor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "codigo_distribuidor",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filters.codigo_distribuidor"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Consultor" } },
                                    [
                                      _c("b-form-input", {
                                        model: {
                                          value: _vm.filters.consultor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "consultor",
                                              $$v
                                            )
                                          },
                                          expression: "filters.consultor"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Classe" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          options: _vm.classes,
                                          readonly: _vm.isCenter
                                        },
                                        model: {
                                          value:
                                            _vm.filters.classe_distribuidor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "classe_distribuidor",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filters.classe_distribuidor"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Inclusão De" } },
                                    [
                                      _c("date-picker", {
                                        attrs: { config: _vm.datePickerConfig },
                                        model: {
                                          value: _vm.filters.fromDateCreated,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "fromDateCreated",
                                              $$v
                                            )
                                          },
                                          expression: "filters.fromDateCreated"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Inclusão Até" } },
                                    [
                                      _c("date-picker", {
                                        attrs: { config: _vm.datePickerConfig },
                                        model: {
                                          value: _vm.filters.toDateCreated,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "toDateCreated",
                                              $$v
                                            )
                                          },
                                          expression: "filters.toDateCreated"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Aprovação De" } },
                                    [
                                      _c("date-picker", {
                                        attrs: { config: _vm.datePickerConfig },
                                        model: {
                                          value: _vm.filters.fromDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "fromDate",
                                              $$v
                                            )
                                          },
                                          expression: "filters.fromDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Aprovação Até" } },
                                    [
                                      _c("date-picker", {
                                        attrs: {
                                          id: "ate",
                                          config: _vm.datePickerConfig
                                        },
                                        model: {
                                          value: _vm.filters.toDate,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "toDate", $$v)
                                          },
                                          expression: "filters.toDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { attrs: { "align-v": "end" } },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Indicado Por:" } },
                                    [
                                      _c(
                                        "v-select",
                                        {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: ["#######"],
                                              expression: "['#######']"
                                            }
                                          ],
                                          attrs: {
                                            options: _vm.listaDistribuidores,
                                            placeholder:
                                              "Código do Distribuidor"
                                          },
                                          on: { search: _vm.buscaDistribuidor },
                                          model: {
                                            value:
                                              _vm.filters.indicanteSelecionado,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "indicanteSelecionado",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filters.indicanteSelecionado"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "no-options" },
                                              slot: "no-options"
                                            },
                                            [
                                              _vm._v(
                                                "Nenhum distribuidor encontrado"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          model: {
                                            value: _vm.filters.hasIndicante,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "hasIndicante",
                                                $$v
                                              )
                                            },
                                            expression: "filters.hasIndicante"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Apenas Indicados\n                  "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          model: {
                                            value: _vm.filters.cnaePendente,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "cnaePendente",
                                                $$v
                                              )
                                            },
                                            expression: "filters.cnaePendente"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Apenas Pendência de CNAE\n                  "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini", disabled: _vm.loading },
                          model: {
                            value: _vm.filters.status,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "status", $$v)
                            },
                            expression: "filters.status"
                          }
                        },
                        _vm._l(_vm.statusOptions, function(stat) {
                          return _c(
                            "el-radio-button",
                            { key: stat.text, attrs: { label: stat.value } },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("span", { staticClass: "ml-1" }, [
                                    _vm._v(_vm._s(stat.text))
                                  ])
                                ]
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.loading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "border rounded p-3 d-flex align-items-center"
                        },
                        [
                          _c("i", { staticClass: "el-icon-loading mr-2" }),
                          _vm._v(
                            "\n          Carregando prospectos...\n        "
                          )
                        ]
                      )
                    : !_vm.loading && _vm.prospectos.length > 0
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          staticClass: "rounded",
                          attrs: {
                            "empty-text": "Nenhum prospecto encontrado.",
                            data: _vm.prospectos,
                            align: "center",
                            border: "",
                            "row-key": "id",
                            size: "mini",
                            "expand-row-keys": _vm.expandedRows
                          },
                          on: { "expand-change": _vm.handleExpand }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "expand" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return _c("div", {}, [
                                    _c(
                                      "div",
                                      { staticClass: "px-3" },
                                      [
                                        _c(
                                          "el-row",
                                          { attrs: { gutter: 12 } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 16 } },
                                              [
                                                _c(
                                                  "el-tabs",
                                                  {
                                                    attrs: {
                                                      type: "border-card"
                                                    },
                                                    model: {
                                                      value: _vm.activeTabName,
                                                      callback: function($$v) {
                                                        _vm.activeTabName = $$v
                                                      },
                                                      expression:
                                                        "activeTabName"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-tab-pane",
                                                      {
                                                        attrs: { name: "first" }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              slot: "label"
                                                            },
                                                            slot: "label"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-folder"
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "ml-1"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Dados Adicionais"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-card",
                                                          [
                                                            _c(
                                                              "el-descriptions",
                                                              {
                                                                attrs: {
                                                                  title:
                                                                    "Informações",
                                                                  column: 4,
                                                                  size: "mini",
                                                                  border: true
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot:
                                                                      "extra"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "d-flex align-items-center"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-button",
                                                                          {
                                                                            style: {
                                                                              width:
                                                                                "100%"
                                                                            },
                                                                            attrs: {
                                                                              size:
                                                                                "mini",
                                                                              type:
                                                                                "warning",
                                                                              plain:
                                                                                "",
                                                                              title:
                                                                                "Editar prospecto",
                                                                              disabled:
                                                                                _vm.loading &&
                                                                                _vm.isGestor &&
                                                                                  [
                                                                                    "AGUARDANDO",
                                                                                    "PRE-CADASTRO",
                                                                                    "ATIVO"
                                                                                  ].includes(
                                                                                    scope
                                                                                      .row
                                                                                      .status
                                                                                  )
                                                                            },
                                                                            nativeOn: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.preventDefault()
                                                                                return _vm.navigateToProspectEdit(
                                                                                  scope
                                                                                    .row
                                                                                    .id
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "el-icon-edit"
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              "\n                                                Editar Prospecto\n                                              "
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-button",
                                                                          {
                                                                            style: {
                                                                              width:
                                                                                "100%"
                                                                            },
                                                                            attrs: {
                                                                              size:
                                                                                "mini",
                                                                              type:
                                                                                "primary",
                                                                              plain:
                                                                                "",
                                                                              disabled:
                                                                                _vm.loading,
                                                                              title:
                                                                                "Ver prospecto"
                                                                            },
                                                                            nativeOn: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.preventDefault()
                                                                                return _vm.navigateToProspectShow(
                                                                                  scope
                                                                                    .row
                                                                                    .id
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "el-icon-right"
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              "\n                                                Ver prospecto\n                                              "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-descriptions-item",
                                                                  {
                                                                    attrs: {
                                                                      span: 2
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot:
                                                                          "label"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Prospecto"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "d-flex align-items-center justify-content-between"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .pessoa_juridica
                                                                                  .nome_fantasia
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex align-items-center"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "el-tag",
                                                                              {
                                                                                staticClass:
                                                                                  "mr-2",
                                                                                attrs: {
                                                                                  type:
                                                                                    "info",
                                                                                  size:
                                                                                    "mini"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "#" +
                                                                                    _vm._s(
                                                                                      scope
                                                                                        .row
                                                                                        .id
                                                                                    )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "el-button",
                                                                              {
                                                                                attrs: {
                                                                                  size:
                                                                                    "mini",
                                                                                  circle:
                                                                                    ""
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.copyThis(
                                                                                      scope
                                                                                        .row
                                                                                        .id
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "el-icon-document-copy"
                                                                                  }
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  2
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-descriptions-item",
                                                                  {
                                                                    attrs: {
                                                                      span: 2
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot:
                                                                          "label"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Responsável"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-tag",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "mini"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " \n                                              " +
                                                                            _vm._s(
                                                                              (scope
                                                                                .row
                                                                                .prospecto_empresa &&
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .responsavel &&
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .responsavel
                                                                                  .pessoa_fisica &&
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .responsavel
                                                                                  .pessoa_fisica
                                                                                  .nome) ||
                                                                                "Responsável não cadastrado"
                                                                            ) +
                                                                            "\n                                            "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  2
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-descriptions-item",
                                                                  {
                                                                    attrs: {
                                                                      span: 2
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot:
                                                                          "label"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Classe"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-tag",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "mini"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            scope
                                                                              .row
                                                                              .classe_distribuidor ||
                                                                              "-"
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  2
                                                                ),
                                                                _vm._v(" "),
                                                                !scope.row
                                                                  .tipo_pessoa_fisica &&
                                                                scope.row
                                                                  .prospecto_empresa &&
                                                                scope.row
                                                                  .prospecto_empresa
                                                                  .pessoa_juridica
                                                                  ? _c(
                                                                      "el-descriptions-item",
                                                                      {
                                                                        attrs: {
                                                                          span: 2
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "template",
                                                                          {
                                                                            slot:
                                                                              "label"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "CNPJ"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex align-items-center justify-content-between"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                " +
                                                                                _vm._s(
                                                                                  (scope
                                                                                    .row
                                                                                    .prospecto_empresa &&
                                                                                    scope
                                                                                      .row
                                                                                      .prospecto_empresa
                                                                                      .pessoa_juridica &&
                                                                                    scope
                                                                                      .row
                                                                                      .prospecto_empresa
                                                                                      .pessoa_juridica
                                                                                      .cnpj) ||
                                                                                    "-"
                                                                                ) +
                                                                                "\n                                                "
                                                                            ),
                                                                            scope
                                                                              .row
                                                                              .prospecto_empresa
                                                                              .pessoa_juridica
                                                                              .cnpj
                                                                              ? _c(
                                                                                  "el-button",
                                                                                  {
                                                                                    attrs: {
                                                                                      size:
                                                                                        "mini",
                                                                                      circle:
                                                                                        ""
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.copyThis(
                                                                                          scope
                                                                                            .row
                                                                                            .prospecto_empresa
                                                                                            .pessoa_juridica
                                                                                            .cnpj
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "el-icon-document-copy"
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _c(
                                                                      "el-descriptions-item",
                                                                      {
                                                                        attrs: {
                                                                          span: 2
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "template",
                                                                          {
                                                                            slot:
                                                                              "label"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "CPF"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex align-items-center justify-content-between"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                " +
                                                                                _vm._s(
                                                                                  (scope
                                                                                    .row
                                                                                    .prospecto_empresa &&
                                                                                    scope
                                                                                      .row
                                                                                      .prospecto_empresa
                                                                                      .responsavel &&
                                                                                    scope
                                                                                      .row
                                                                                      .prospecto_empresa
                                                                                      .responsavel
                                                                                      .pessoa_fisica &&
                                                                                    scope
                                                                                      .row
                                                                                      .prospecto_empresa
                                                                                      .responsavel
                                                                                      .pessoa_fisica
                                                                                      .cpf) ||
                                                                                    "-"
                                                                                ) +
                                                                                " \n                                                "
                                                                            ),
                                                                            scope
                                                                              .row
                                                                              .prospecto_empresa
                                                                              .responsavel
                                                                              .pessoa_fisica
                                                                              .cpf
                                                                              ? _c(
                                                                                  "el-button",
                                                                                  {
                                                                                    attrs: {
                                                                                      size:
                                                                                        "mini",
                                                                                      circle:
                                                                                        ""
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.copyThis(
                                                                                          scope
                                                                                            .row
                                                                                            .prospecto_empresa
                                                                                            .responsavel
                                                                                            .pessoa_fisica
                                                                                            .cpf
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "el-icon-document-copy"
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      2
                                                                    ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-descriptions-item",
                                                                  {
                                                                    attrs: {
                                                                      span: 2
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot:
                                                                          "label"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Cadastro tipo pessoa física?"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-tag",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "mini",
                                                                          type: scope
                                                                            .row
                                                                            .tipo_pessoa_fisica
                                                                            ? "primary"
                                                                            : "info"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            scope
                                                                              .row
                                                                              .tipo_pessoa_fisica
                                                                              ? "Sim"
                                                                              : "Não"
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  2
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-descriptions-item",
                                                                  {
                                                                    attrs: {
                                                                      span: 2
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot:
                                                                          "label"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Cidade"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-tag",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "mini"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " \n                                              " +
                                                                            _vm._s(
                                                                              (scope
                                                                                .row
                                                                                .prospecto_empresa &&
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .endereco &&
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .endereco
                                                                                  .cidade &&
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .endereco
                                                                                  .cidade
                                                                                  .nome) ||
                                                                                "-"
                                                                            ) +
                                                                            "\n                                              -\n                                              " +
                                                                            _vm._s(
                                                                              (scope
                                                                                .row
                                                                                .prospecto_empresa &&
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .endereco &&
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .endereco
                                                                                  .cidade &&
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .endereco
                                                                                  .cidade
                                                                                  .estado &&
                                                                                scope
                                                                                  .row
                                                                                  .prospecto_empresa
                                                                                  .endereco
                                                                                  .cidade
                                                                                  .estado
                                                                                  .uf) ||
                                                                                "-"
                                                                            ) +
                                                                            "\n                                            "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  2
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-descriptions-item",
                                                                  {
                                                                    attrs: {
                                                                      span: 2
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot:
                                                                          "label"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Criado em"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "d-flex align-items-center"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "el-icon-time"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "ml-2"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.formatDate(
                                                                                  scope
                                                                                    .row
                                                                                    .created_at,
                                                                                  "DD/MM/YYYY"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  2
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-descriptions-item",
                                                                  {
                                                                    attrs: {
                                                                      span: 2
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot:
                                                                          "label"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Digitado por"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "d-flex align-items-center"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                scope
                                                                                  .row
                                                                                  .user
                                                                                  .name
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  2
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-descriptions-item",
                                                                  {
                                                                    attrs: {
                                                                      span: 2
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot:
                                                                          "label"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Pendência CNAE"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-tag",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "mini",
                                                                          type: scope
                                                                            .row
                                                                            .cnae_pendente
                                                                            ? "primary"
                                                                            : "info"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            scope
                                                                              .row
                                                                              .cnae_pendente
                                                                              ? "Sim"
                                                                              : "Não"
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  2
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-descriptions-item",
                                                                  {
                                                                    attrs: {
                                                                      span: 2
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "template",
                                                                      {
                                                                        slot:
                                                                          "label"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Possui pedido faturado?"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-tag",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "mini",
                                                                          type: scope
                                                                            .row
                                                                            .possui_pedido_faturado
                                                                            ? "primary"
                                                                            : "info"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            scope
                                                                              .row
                                                                              .possui_pedido_faturado
                                                                              ? "Sim"
                                                                              : "Não"
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  2
                                                                )
                                                              ],
                                                              2
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "el-tab-pane",
                                                      {
                                                        attrs: {
                                                          name: "second"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "label"
                                                            },
                                                            slot: "label"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-items-center",
                                                                style: {
                                                                  gap: "8px"
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-chat-line-round"
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "d-flex align-items-center",
                                                                    style: {
                                                                      gap:
                                                                        "12px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "Comentários"
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    scope.row
                                                                      .observacoes !=
                                                                    undefined
                                                                      ? _c(
                                                                          "el-tag",
                                                                          {
                                                                            attrs: {
                                                                              size:
                                                                                "small",
                                                                              type:
                                                                                "warning"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                scope
                                                                                  .row
                                                                                  .observacoes
                                                                                  .length
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-card",
                                                          [
                                                            scope.row
                                                              .observacoes
                                                              .length > 0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle: {
                                                                      "max-height":
                                                                        "300px",
                                                                      "overflow-y":
                                                                        "auto"
                                                                    }
                                                                  },
                                                                  _vm._l(
                                                                    scope.row
                                                                      .observacoes,
                                                                    function(
                                                                      value
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key:
                                                                            value.id,
                                                                          staticClass:
                                                                            "mb-2"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b-card",
                                                                            [
                                                                              _c(
                                                                                "b-card-text",
                                                                                [
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-1"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "b",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Comentário de:"
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            value
                                                                                              .user
                                                                                              .name
                                                                                          ) +
                                                                                          "\n                                            "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-1"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "b",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Data:"
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            value.created_at
                                                                                          ) +
                                                                                          "\n                                            "
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "hr",
                                                                                    {
                                                                                      staticClass:
                                                                                        "my-2"
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-0"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          value.observacao
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                )
                                                              : _c("el-empty", {
                                                                  attrs: {
                                                                    description:
                                                                      "Nenhum comentário para exibir"
                                                                  }
                                                                })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center my-3 px-3",
                                                    style: { gap: "12px" }
                                                  },
                                                  [
                                                    [
                                                      "DIGITADO",
                                                      "PENDENTE",
                                                      "INATIVO"
                                                    ].includes(
                                                      scope.row.status
                                                    ) && _vm.isAuthorized
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "success",
                                                              plain: "",
                                                              size: "small"
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.showModalAprovacaoFinanceira(
                                                                  scope.row.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "b-icon-check-circle"
                                                            ),
                                                            _vm._v(
                                                              " \n                                Enviar p/ Financeiro\n                              "
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    scope.row.cnae_pendente
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "info",
                                                              plain: "",
                                                              size: "small"
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.limparPendenciaCnae(
                                                                  scope.row.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "b-icon-check2-circle"
                                                            ),
                                                            _vm._v(
                                                              " \n                                Limpar Pendência de CNAE\n                              "
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    scope.row.cnae_pendente
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "warning",
                                                              plain: "",
                                                              size: "small"
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.zerarLimiteCnae(
                                                                  scope.row.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-odometer"
                                                            }),
                                                            _vm._v(
                                                              "\n                                Zerar Limite de Crédito\n                              "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    scope.row.status ===
                                                    "INATIVO"
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "danger",
                                                              plain: "",
                                                              size: "small",
                                                              disabled:
                                                                _vm.isGestor
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.confirmaProspecto(
                                                                  scope.row.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-delete"
                                                            }),
                                                            _vm._v(
                                                              "\n                                Excluir\n                              "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Prospecto",
                              width: "80",
                              prop: "id",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return _c("div", {}, [
                                    _vm._v(_vm._s(scope.row.id))
                                  ])
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Código Vend.",
                              width: "120",
                              prop: "id",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return _c("div", {}, [
                                    _vm._v(_vm._s(scope.row.codigo_vendedor))
                                  ])
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Código Distr.",
                              width: "120",
                              prop: "id",
                              align: "left"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return scope.row.distribuidor
                                      ? _c("div", {}, [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.distribuidor.codigo
                                            )
                                          )
                                        ])
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "info",
                                              size: "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              Não associado\n            "
                                            )
                                          ]
                                        )
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "320",
                              label: "Nome",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.prospecto_empresa.pessoa_juridica
                                      .nome_fantasia
                                      ? _c(
                                          "span",
                                          { staticClass: "text-truncate" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  scope.row.prospecto_empresa
                                                    .pessoa_juridica
                                                    .nome_fantasia
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _c("span", [_vm._v("Sem nome")])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "UF", width: "60", align: "left" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.prospecto_empresa.endereco
                                            .cidade.estado.uf
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Classe",
                              width: "80",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-tag", { attrs: { size: "small" } }, [
                                      _vm._v(
                                        _vm._s(scope.row.classe_distribuidor)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Status",
                              width: "130",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.status
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type:
                                                scope.row.status == "ATIVO"
                                                  ? "success"
                                                  : scope.row.status ==
                                                    "DIGITADO"
                                                  ? "primary"
                                                  : scope.row.status ==
                                                    "PRE_CADASTRO"
                                                  ? "info"
                                                  : scope.row.status ==
                                                    "PENDENTE"
                                                  ? "warning"
                                                  : "danger"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(scope.row.status) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Tipo Cadastro",
                              width: "120",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.tipo_cadastro
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type:
                                                scope.row.tipo_cadastro ===
                                                "NOVO"
                                                  ? "success"
                                                  : "primary"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  scope.row.tipo_cadastro
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              width: "200",
                              label: "Cadastrado Por",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.user
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-truncate text-capitalize"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  scope.row.user.name.toLowerCase()
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "info",
                                              size: "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Não Associado\n                "
                                            )
                                          ]
                                        )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              width: "115",
                              label: "Indicado Por",
                              align: "left"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.indicante
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                scope.row.indicante.codigo
                                              ) +
                                              "\n                "
                                          )
                                        ])
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "info",
                                              size: "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Não Associado\n                "
                                            )
                                          ]
                                        )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Criado em",
                              width: "130",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-center"
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-time"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "ml-2" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(
                                                scope.row.created_at
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Aprovado em",
                              width: "150",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.dt_aprova_financeiro
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center justify-content-center"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-time"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "ml-2" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatDate(
                                                      scope.row
                                                        .dt_aprova_financeiro
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "warning",
                                              size: "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Não Aprovado\n                  "
                                            )
                                          ]
                                        )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Última atualização",
                              width: "140",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-center"
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-time"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "ml-2" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(
                                                scope.row.updated_at
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: {
                                fixed: "right",
                                width: 50,
                                align: "right"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between"
                                        },
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                placement: "bottom-end",
                                                trigger: "hover"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    slot: "reference",
                                                    size: "mini",
                                                    type: "info",
                                                    plain: "",
                                                    circle: "",
                                                    disabled: _vm.loading
                                                  },
                                                  slot: "reference"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-more"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  style: {
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                    flexDirection: "column",
                                                    gap: "4px",
                                                    maxWidth: "300px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      style: { width: "100%" }
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          style: {
                                                            width: "100%"
                                                          },
                                                          attrs: {
                                                            size: "mini",
                                                            type: "warning",
                                                            plain: "",
                                                            title:
                                                              "Editar usuário",
                                                            disabled:
                                                              _vm.loading &&
                                                              _vm.isGestor &&
                                                                [
                                                                  "AGUARDANDO",
                                                                  "PRE-CADASTRO",
                                                                  "ATIVO"
                                                                ].includes(
                                                                  scope.row
                                                                    .status
                                                                )
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.navigateToProspectEdit(
                                                                scope.row.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-edit"
                                                          }),
                                                          _vm._v(
                                                            "\n                        Editar Prospecto\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      style: { width: "100%" }
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          style: {
                                                            width: "100%"
                                                          },
                                                          attrs: {
                                                            size: "mini",
                                                            type: "primary",
                                                            plain: "",
                                                            disabled:
                                                              _vm.loading,
                                                            title:
                                                              "Ver prospecto"
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.navigateToProspectShow(
                                                                scope.row.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-right"
                                                          }),
                                                          _vm._v(
                                                            "\n                        Ver prospecto\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { slot: "header" },
                                  slot: "header"
                                },
                                [_c("i", { staticClass: "el-icon-menu" })]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _c("el-empty", {
                        attrs: { description: "Nenhum prospecto disponível" }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "el-col",
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          "current-page": _vm.currentPage,
                          "page-sizes": [15, 50, 75, 100],
                          "page-size": _vm.perPage,
                          layout: "total, sizes, prev, pager, next",
                          total: _vm.totalRows
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.currentPage = $event
                          },
                          "update:current-page": function($event) {
                            _vm.currentPage = $event
                          },
                          "current-change": function($event) {
                            return _vm.loadProspectos()
                          },
                          "size-change": _vm.handleSizeChange
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Confirmação de Envio", centered: "" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modalAprova = false
                        }
                      }
                    },
                    [_vm._v("\n        Cancelar\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", disabled: _vm.loading },
                      on: { click: _vm.solicitarAprovacaoFinanceira }
                    },
                    [
                      _vm.loading
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v("\n        Sim, Enviar\n      ")
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalAprova,
            callback: function($$v) {
              _vm.modalAprova = $$v
            },
            expression: "modalAprova"
          }
        },
        [
          _c("h4", { staticClass: "text-info" }, [
            _vm._v(
              "\n      Deseja realmente enviar para aprovação financeira?\n    "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65a066ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65a066ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_prospecto/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-65a066ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_prospecto/Index.vue
// module chunks = 2